<template>
	<nav class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl" v-bind="$attrs" id="navbarBlur" data-scroll="true">
		<div class="px-3 py-1 container-fluid">
			<breadcrumbs :currentPage="currentRouteName" textWhite="text-white" />

			<div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4" :class="'me-sm-4'" id="navbar">
				<ul class="navbar-nav justify-content-end ms-md-auto">
					<li class="nav-item d-xl-none ps-3 d-flex align-items-center">
						<a href="#" @click="toggleSidebar" class="p-0 nav-link text-white" id="iconNavbarSidenav">
							<div class="sidenav-toggler-inner">
								<i class="sidenav-toggler-line bg-white"></i>
								<i class="sidenav-toggler-line bg-white"></i>
								<i class="sidenav-toggler-line bg-white"></i>
							</div>
						</a>
					</li>
					<li class="nav-item dropdown d-flex align-items-center px-3" :class="'pe-2'">
						<a href="#" class="p-0 nav-link text-white" :class="[showMenu ? 'show' : '']" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false" @click="showMenu = !showMenu">
							<i class="cursor-pointer fa fa-cog"></i>
						</a>
						<ul class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4 user-menu" :class="showMenu ? 'show' : ''" aria-labelledby="dropdownMenuButton">
							<li>
								<a class="dropdown-item border-radius-md" href="javascript:;" @click="logout()">
									<div class="py-1 d-flex">
										<div class="my-auto">
											<i class="ni ni-button-power" />
										</div>
										<div class="d-flex flex-column justify-content-center">
											<h6 class="mb-1 text-sm font-weight-normal"><span class="font-weight-bold">Sair</span></h6>
										</div>
									</div>
								</a>
							</li>
							<!-- button-power -->
						</ul>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</template>
<script>
import Breadcrumbs from '../Breadcrumbs.vue'
import { mapMutations, mapActions } from 'vuex'

export default {
	name: 'navbar',
	data() {
		return {
			showMenu: false,
		}
	},
	props: ['minNav', 'textWhite'],
	created() {
		this.minNav
	},
	methods: {
		...mapMutations(['navbarMinimize', 'toggleConfigurator']),
		...mapActions(['toggleSidebarColor']),

		toggleSidebar() {
			this.toggleSidebarColor('bg-white')
			this.navbarMinimize()
		},

		logout() {
			localStorage.removeItem('access_token_cg')
			localStorage.removeItem('refresh_token_cg')
			this.$store.commit('logoutUser')
			this.$router.push('/login')
		},
	},
	components: {
		Breadcrumbs,
	},
	computed: {
		currentRouteName() {
			return this.$route.name
		},
	},
}
</script>
<style lang="scss" scoped>
.user-menu {
	.dropdown-item {
		div {
			justify-content: flex-start;
			align-items: center;
			gap: 10px;

			i {
				color: white;
			}
		}
	}
}
</style>
